import * as eV from './core/nEvents';

import CartQuantity from '../components/Cart/cartQuantity/cartQuantity';
import Discount from '../components/Cart/discountField/discountField';
import discountInfo from '../components/Cart/discountInfo/discountInfo';
import cartDelivery from '../components/Cart/delivery/delivery';
import {removeProduct, reloadCart} from "../components/Cart/cartActions/cartActions";

const Cart = () => {
	let showNipBtn = document.querySelector('#show-nip');
	let showableNip = document.querySelector('#showable-nip');
	let invoiceReceiverCheck = document.querySelector('#show-invoice-receive-data');

	let showCustomDeliveryBtn = document.querySelector('#show-custom-delivery');
	let showableCustomDelivery = document.querySelector('#showable-custom-delivery');
	let invoiceReceiverContainer = document.querySelector('#invoice-receiver-data');
	
	let ddfFvTypeChangers = document.getElementsByClassName('JS_ddf-fd-type-changer');
	let ddfFvType = document.getElementsByClassName('JS_ddf-fv-type');
	
	CartQuantity();
	Discount();

	eV.click(showNipBtn, () => showableNip.classList.toggle('hidden'));
	eV.click(showCustomDeliveryBtn, () => showableCustomDelivery.classList.toggle('hidden'));
	
	[...ddfFvTypeChangers].map(element => {
		element.addEventListener('change', e => {
			let val = e.currentTarget.value;
			
			[...ddfFvType].map(container => {
				container.classList.add('hidden');
				
				if(container.dataset.type == val) {
					container.classList.toggle('hidden');
				}
			});
		});
	});
	
	if(invoiceReceiverCheck && invoiceReceiverContainer) {
		eV.click(invoiceReceiverCheck, () => invoiceReceiverContainer.classList.toggle('hidden'));
	}

	// let removeBtns = document.getElementsByClassName('js-remove-product-from-cart');
	//
	// if (removeBtns) {
	// 	[...removeBtns].map(btn => {
	// 		btn.addEventListener('click', () => removeProduct(reloadCart));
	// 	});
	// }
};


export {Cart};


// WEBPACK FOOTER //
// ./js/Cart.js